import React, { lazy } from 'react';
import { CarFront, Wrench, Car, Truck, DoorOpen, PhoneCall, ArrowRight, ShieldCheck } from 'lucide-react';
export function Services() {
  const services = [{
    icon: CarFront,
    title: 'Emergency Windshield Replacement',
    copy: "For cracked, shattered or unsafe windshields, Kosin's Glass provides professional windshield replacement with certified technicians and quality glass options."
  }, {
    icon: Wrench,
    title: 'Broken Windshield Repair Today',
    copy: "Small chips may be repairable before they spread. Kosin's Glass can inspect the damage and explain whether chip repair or replacement is safer."
  }, {
    icon: Car,
    title: 'Shattered Side Window Replacement',
    copy: 'Driver side, passenger side and power window glass replacement for broken or shattered side windows.'
  }, {
    icon: CarFront,
    title: 'Rear Window Replacement',
    copy: 'Replacement for broken rear vehicle glass, back windows, truck rear glass and other damaged rear window glass.'
  }, {
    icon: DoorOpen,
    title: 'Car Door & Quarter Glass',
    copy: 'Replacement for car door glass, quarter glass, vent glass and other urgent vehicle glass damage.'
  }, {
    icon: Truck,
    title: 'Truck, Van, Fleet & Semi Glass',
    copy: 'Urgent glass repair and replacement options for trucks, vans, commercial vehicles, fleets and semi trucks.'
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-317">
      <div className="max-w-7xl mx-auto" data-id="element-318">
        {/* Image + intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-14" data-id="element-319">
          <div className="relative" data-id="element-320">
            <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200 aspect-[4/3]" data-id="element-321">
              <img src="https://cdn.magicpatterns.com/uploads/iwR2zxogSUd82yEgZeaCw8/Emergency_Auto.png" alt="Kosin's Glass technician carefully inspecting a cracked windshield with a flashlight before recommending repair or replacement" className="w-full h-full object-cover" loading="lazy" data-id="element-322" />
            </div>
            <div className="hidden sm:flex absolute -bottom-5 -right-5 bg-white border border-slate-200 shadow-md rounded-xl px-4 py-3 items-center gap-3" data-id="element-323">
              <div className="bg-brand-redLight p-2 rounded-lg" data-id="element-324">
                <ShieldCheck className="w-5 h-5 text-brand-red" data-id="element-325" />
              </div>
              <div data-id="element-326">
                <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide" data-id="element-327">
                  Certified
                </div>
                <div className="text-sm font-bold text-slate-900" data-id="element-328">
                  Auto Glass Technicians
                </div>
              </div>
            </div>
          </div>

          <div data-id="element-329">
            <div className="inline-flex items-center gap-2 bg-brand-redLight text-brand-red px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-5 border border-brand-redBorder" data-id="element-330">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-red" data-id="element-331" />
              Emergency Auto Glass
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-5 tracking-tight leading-tight" data-id="element-332">
              <span className="text-brand-red" data-id="element-333">Auto Glass Services</span> for
              Broken Vehicle Glass
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-334">
              When vehicle glass breaks you need clear answers fast. Kosin's
              Glass can inspect the damage, explain whether repair or
              replacement is needed, and help schedule the fastest available
              option.
            </p>
          </div>
        </div>

        {/* Service cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-335">
          {services.map((service, i) => <div key={i} className="bg-white rounded-xl p-6 border border-slate-200 hover:border-brand-red/40 hover:shadow-md transition-all" data-id="element-336">
              <div className="w-12 h-12 bg-brand-redLight rounded-lg flex items-center justify-center mb-5" data-id="element-337">
                <service.icon className="w-6 h-6 text-brand-red" data-id="element-338" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-339">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-340">{service.copy}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-341">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-342">
            <PhoneCall className="w-5 h-5" data-id="element-343" />
            Check Today's Auto Glass Openings
            <ArrowRight className="w-4 h-4" data-id="element-344" />
          </a>
        </div>
      </div>
    </section>;
}